import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Application from '../Application/Application';
import Group from '../Group/Group';
import Input from './Input';

class InputExample extends Component {

  state = {
    label: 'Label for input',
    placeholder: 'Enter text or tags',
    options: ['one', 'two', 'three', 'ten', 'thirty', 'these', 'are', 'the', 'selected', 'tags'], // autocomplete with array of strings
    // options: [ // autocomplete with array of objects
    //   {
    //     label: 'Option 1',
    //     value: 'option-1',
    //   }, {
    //     label: 'Option 2',
    //     value: 'option-2',
    //   }, {
    //     label: 'Option 3',
    //     value: 'option-3',
    //   },
    // ],
    asyncOptions: [],
    asyncValue: '',
  };

  onChangeProps = e => this.setState(e.target.value);

  onChange = e => {
    let value = e.target.value;

    if (typeof value === 'object') {
      value = value.label;
    }
    this.setState({ value });
  };

  onChangeAsync = e => {
    const COMPANY = 'Vimond Media Solutions';
    const value = e.target.value;

    this.setState({ asyncValue: value });
    setTimeout(() => {
      this.setState({
        asyncOptions: COMPANY.toLowerCase().indexOf(value.toLowerCase()) === 0 ? [COMPANY] : undefined,
      });
    }, 500);
  };

  onUnlock = e => {
    window.showAppInfo('unlock icon');
    Application.showWarningDialog(
      'Unlock critical fields?',
      'This will unlock all critical fields and make them editable.',
      'Unlock', 'No', null,
      e => {
        this.setState({ locked: !this.state.locked });
      }
    );
 };

 repaint = e => this.forceUpdate();

 render() {
   const { asyncOptions, asyncValue, ...rest } = this.state;

   return (
     <Example {...this.props}>
       <Properties defaultProps={Input.defaultProps} propTypes={Input.propTypes} propValues={this.state}
         onChange={this.onChangeProps}/>
       <Group>
         <Input {...rest} onChange={this.onChange} onFocus={this.repaint} onBlur={this.repaint} onUnlock={this.onUnlock}/>
         <Input value={asyncValue} options={asyncOptions} label="Asynchronously fetched options (500ms delay)" placeholder="Type Vimond" onChange={this.onChangeAsync}/>
       </Group>
       <SourceCode querySelector=".page > div > .core-input"/>
     </Example>
   );
 }

}

InputExample.tags = 'text';

export default InputExample;
